import { ChannelFilters } from 'stream-chat';
import { useMemo } from 'react';
import { ChatGenerics } from '../streamTypes';
import { useProfileChatData } from '../ChatProvider';

/**
 * @param showFrozen
 * This filter must be used to query getStream channel related data
 * otherwise an access violation error will be returned
 */
export const useChannelRequiredFilters = (
  showFrozen: boolean = false,
): ChannelFilters<ChatGenerics> => {
  const { user_id: chatUserId } = useProfileChatData();

  return useMemo(() => ({
    type: 'messaging',
    members: { $in: chatUserId ? [chatUserId] : ['-1'] },
    ...(showFrozen ? {} : { frozen: false }),
  }), [chatUserId, showFrozen]);
};
